import React, { useState } from 'react';
import ReactGA from 'react-ga4';
import { useSearchParams } from 'react-router-dom';

import Botao from 'Component/Botao';
import { CursoCartao } from 'Component/Curso';
import Icone from 'Component/Icone';
import Paginacao from 'Component/Paginacao';
import { useRecuperarCursosQuery } from 'Service';

const Buscar = (): React.ReactElement => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [termo, setTermo] = useState<string>('');
  const { data: { cursos, paginacao } = {}, isFetching } =
    useRecuperarCursosQuery({
      contain: ['Categorias'],
      page: searchParams.get('pagina') || 1,
      options: { busca: { termo: searchParams.get('termo') || '' } },
    });

  const enviar = (termoForcado: string | null) => {
    if (termoForcado) {
      setTermo(termoForcado);
      searchParams.set('termo', termoForcado);
    } else if (termo) {
      searchParams.set('termo', termo);
    } else {
      searchParams.delete('termo');
    }

    ReactGA.event('search', { search_term: termoForcado || termo });

    setSearchParams(searchParams);
  };

  return (
    <div
      className="animate__animated animate__fadeIn"
      style={{ minHeight: window.outerHeight }}
    >
      <div
        className="hf-400 d-flex align-items-end"
        style={{
          backgroundImage:
            'linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 100%), url(/img/meus-cursos.jpg)',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          marginTop: '-130px',
        }}
      >
        <div className="container text-center mb-5">
          <h1 className="display-2 text-white">Buscar cursos</h1>
          <p className="lead text-muted">
            O que você está procurando? Conta pra gente que nós tentamos achar o
            melhor conteúdo para você!
          </p>
        </div>
      </div>
      <div className="container-fluid mb-5">
        <div className="row px-3">
          <div className="col-md-3 mb-5 mb-sm-0">
            <div className="input-group input-group-lg">
              <input
                type="text"
                className="form-control form-control-lg bg-dark border-darkless p-4 text-white"
                placeholder="O que procura?"
                value={termo}
                onChange={(e) => setTermo(e.target.value)}
                onKeyUp={(e) => (e.key === 'Enter' ? enviar(null) : null)}
              />
              <Botao
                tema="outline-secondary"
                icone="search"
                onClick={() => enviar(null)}
              />
            </div>
            <div className="mt-4">
              <p className="fs-4 text-muted">
                <Icone nome="hand-index" className="text-secondary me-2" />
                Algumas sugestões
              </p>
              <ul className="list-group list-group-flush fs-5">
                <li
                  className="list-group-item bg-transparent text-white border-dark"
                  onClick={() => enviar('Cursos para professores')}
                >
                  Cursos para professores
                </li>
                <li
                  className="list-group-item bg-transparent text-white border-dark"
                  onClick={() => enviar('Gestão')}
                >
                  Gestão
                </li>
                <li
                  className="list-group-item bg-transparent text-white border-dark"
                  onClick={() => enviar('Administração')}
                >
                  Administração
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-9">
            <div className="row">
              {cursos?.map((curso) => (
                <div
                  key={`${curso.id}-${curso.modificado}`}
                  className="col-lg-4 col-xxl-3 mb-3"
                >
                  <CursoCartao dados={curso} />
                </div>
              ))}
            </div>
            <Paginacao dados={paginacao} desabilitado={isFetching} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Buscar;
